import type { IconSvgObject } from './types';

const CoinsYenIcon: IconSvgObject = [
  ["path", { d: "M14 18C18.4183 18 22 14.4183 22 10C22 5.58172 18.4183 2 14 2C9.58172 2 6 5.58172 6 10C6 14.4183 9.58172 18 14 18Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.15657 11C2.42523 12.1176 2 13.4535 2 14.8888C2 18.8162 5.18378 22 9.11116 22C10.5465 22 11.8824 21.5748 13 20.8434", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.5 6.5C11.6667 7.21296 12.4 8.83333 14 9.61111M14 9.61111C15.6 8.83333 16.3333 7.21296 16.5 6.5M14 9.61111V13.5M16.0833 11.1667H11.9167", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CoinsYenIcon;
